<template>
  <a 
    @click="handleEdit" 
    :class="['edit', disabled ? 'text-secondary disabled' : 'text-info']" 
    :disabled="disabled" 
    v-tooltip="$t('form.button.edit')"
  >
    <i class="icon far fa-edit"></i>
  </a>
</template>

<script>
/**
 * RelationEditButton - A reusable component for editing relationships
 * Used in the relations table to maintain clean, modular code
 */
export default {
  props: {
    relation: {
      type: Object,
      required: true
    },
    relationType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onEdit: {
      type: Function,
      required: true
    }
  },

  methods: {
    handleEdit() {
      if (!this.disabled) {
        this.onEdit(this.relationType, this.relation);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit {
  cursor: pointer;
  margin: 0 5px;

  &.disabled {
    cursor: not-allowed;
  }
}
</style>
